import type { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA, textFormatEditor } from "../../../../../utils/commonFunctions";



const IndustryNameColumn: ColDef = {
  ...generateColumn("", `industries`),

  cellRenderer: (props: any) => {
    return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
  },
  filterValueGetter: (props: any) => {
    return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
  },
  tooltipValueGetter: (props: any) => {
    return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
  },
  valueGetter: (props: any) => {
    return props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.join("#");
  },
};





const columnDefs: ColDef[] = [
  idColumn,
  { ...generateColumn("Short Form") },
  IndustryNameColumn,
  {
    ...generateColumn("Long Form","acronym"),
    cellRenderer: (props: any) => {
      return renderNA(props.data?.acronym);
    },
  },
  {
    ...generateColumn("Description", "description"),
    ...textFormatEditor("description"),
  },
  statusColumn,
  actionColumn,
];
export default columnDefs;
